/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type TheGrapefulClubPromo_viewer$ref = any;
export type GrapefulClubPromo_QueryVariables = {};
export type GrapefulClubPromo_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": TheGrapefulClubPromo_viewer$ref;
    }) | null;
};
export type GrapefulClubPromo_Query = {
    readonly response: GrapefulClubPromo_QueryResponse;
    readonly variables: GrapefulClubPromo_QueryVariables;
};



/*
query GrapefulClubPromo_Query {
  viewer {
    id
    ...TheGrapefulClubPromo_viewer
  }
}

fragment TheGrapefulClubPromo_viewer on Viewer {
  id
  ...GrapefulClubPromo_viewer
}

fragment GrapefulClubPromo_viewer on Viewer {
  ...GridGenerator_viewer
  ...GrapefulClubBanner_viewer
  isLoggedIn
  user {
    id
    conciergeUser {
      userId
      permissions {
        id
        oneCommerce {
          id
          preferredCustomer {
            access
          }
        }
      }
      id
    }
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
  }
}

fragment GridGenerator_viewer on Viewer {
  ...MembershipButtons_viewer
  user {
    id
    cart {
      id
      eventId
      event {
        id
        trinityPartyType
      }
      taxRate
      taxTotal
      totalNumberOfItems
      subTotalPriceOfItems
      promoCodeSavings
      viaQualifiedCartTotal
      subTotalPriceOfItemsWithPromoCodes
      entries(first: 1000) {
        edges {
          node {
            id
            product {
              id
              productId
              price
              priceSale
              promoCodeDiscount {
                case4Cause {
                  case12PriceUSD
                  case6PriceUSD
                  case6SKU
                  case12SKU
                  donationEligible
                }
              }
            }
            quantity
          }
        }
      }
    }
  }
  productsBulk(first: 2, productIds: ["a6221ef0-00ea-4b54-8ed8-57b979ef433c", "4d809d88-554d-4897-843b-36fc813cff59"]) {
    edges {
      node {
        id
        productId
        name
        price
        ...ProductListItem_product
      }
    }
  }
}

fragment GrapefulClubBanner_viewer on Viewer {
  ...MembershipButtons_viewer
}

fragment MembershipButtons_viewer on Viewer {
  isLoggedIn
  user {
    id
    ...AuthDialog_user
    conciergeUser {
      userId
      permissions {
        id
        oneCommerce {
          id
          preferredCustomer {
            access
          }
        }
      }
      id
    }
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
  }
}

fragment AuthDialog_user on User {
  id
  role
  email
  lastName
  firstName
  hasSSOAccount
  shoppingWithCeoUser {
    userId
    id
  }
  cart {
    id
    eventId
    eventHostFirstName
  }
}

fragment ProductListItem_product on Product {
  id
  isSubscription
  productPermissions {
    oneCommerce {
      preferredCustomer {
        view
        add
      }
      default {
        view
        add
      }
    }
  }
  ranking
  company
  freeUpsGroundShipping
  productId
  name
  category
  price
  priceUSDmin
  priceUSDmax
  year
  priceSale
  reviewAverage
  productURLslug
  parentProduct
  inventoryText
  reviewTotal
  staticUrl
  images {
    productCatalog
    squareFront
    id
  }
  content {
    impactSmall
    summary
    id
  }
  promoCodeDiscount {
    case4Cause {
      case12PriceUSD
      case6PriceUSD
      case6SKU
      case12SKU
      donationEligible
    }
  }
  inventoryClass
  inventorySKU
  inventoryQuantity
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "promoCodeDiscount",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoCodeDiscount",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "case4Cause",
                "storageKey": null,
                "args": null,
                "concreteType": "Case4Cause",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12PriceUSD",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case6PriceUSD",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case6SKU",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "case12SKU",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "donationEligible",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v6 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "permissions",
        "storageKey": null,
        "args": null,
        "concreteType": "PermissionsType",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "OneCommerceType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "access",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any), v7 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "view",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "add",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "GrapefulClubPromo_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "TheGrapefulClubPromo_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "GrapefulClubPromo_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasSSOAccount",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v0 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v0 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventHostFirstName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "trinityPartyType",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "taxRate",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "taxTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "eventId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "promoCodeSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "viaQualifiedCartTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItemsWithPromoCodes",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000,
                                                    "type": "Int"
                                                }
                                            ],
                                            "concreteType": "CartEntryV3Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV3",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "product",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Product",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v0 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        (v3 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "quantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v6 /*: any*/),
                                        (v0 /*: any*/)
                                    ]
                                },
                                (v6 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "productsBulk",
                            "storageKey": "productsBulk(first:2,productIds:[\"a6221ef0-00ea-4b54-8ed8-57b979ef433c\",\"4d809d88-554d-4897-843b-36fc813cff59\"])",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2,
                                    "type": "Int"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "productIds",
                                    "value": [
                                        "a6221ef0-00ea-4b54-8ed8-57b979ef433c",
                                        "4d809d88-554d-4897-843b-36fc813cff59"
                                    ],
                                    "type": "[String]"
                                }
                            ],
                            "concreteType": "ProductConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "plural": false,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "name",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isSubscription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "productPermissions",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProductPermissions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "oneCommerce",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AppProductPermissionsAccess",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "preferredCustomer",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": (v7 /*: any*/)
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "default",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": (v7 /*: any*/)
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "ranking",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "company",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "freeUpsGroundShipping",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "category",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "priceUSDmin",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "priceUSDmax",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "year",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "reviewAverage",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "productURLslug",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "parentProduct",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryText",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "reviewTotal",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "staticUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "images",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Images",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productCatalog",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "squareFront",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v0 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "content",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "impactSmall",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "summary",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v0 /*: any*/)
                                                    ]
                                                },
                                                (v5 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryClass",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventorySKU",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryQuantity",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "GrapefulClubPromo_Query",
            "id": null,
            "text": "query GrapefulClubPromo_Query {\n  viewer {\n    id\n    ...TheGrapefulClubPromo_viewer\n  }\n}\n\nfragment TheGrapefulClubPromo_viewer on Viewer {\n  id\n  ...GrapefulClubPromo_viewer\n}\n\nfragment GrapefulClubPromo_viewer on Viewer {\n  ...GridGenerator_viewer\n  ...GrapefulClubBanner_viewer\n  isLoggedIn\n  user {\n    id\n    conciergeUser {\n      userId\n      permissions {\n        id\n        oneCommerce {\n          id\n          preferredCustomer {\n            access\n          }\n        }\n      }\n      id\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n  }\n}\n\nfragment GridGenerator_viewer on Viewer {\n  ...MembershipButtons_viewer\n  user {\n    id\n    cart {\n      id\n      eventId\n      event {\n        id\n        trinityPartyType\n      }\n      taxRate\n      taxTotal\n      totalNumberOfItems\n      subTotalPriceOfItems\n      promoCodeSavings\n      viaQualifiedCartTotal\n      subTotalPriceOfItemsWithPromoCodes\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            product {\n              id\n              productId\n              price\n              priceSale\n              promoCodeDiscount {\n                case4Cause {\n                  case12PriceUSD\n                  case6PriceUSD\n                  case6SKU\n                  case12SKU\n                  donationEligible\n                }\n              }\n            }\n            quantity\n          }\n        }\n      }\n    }\n  }\n  productsBulk(first: 2, productIds: [\"a6221ef0-00ea-4b54-8ed8-57b979ef433c\", \"4d809d88-554d-4897-843b-36fc813cff59\"]) {\n    edges {\n      node {\n        id\n        productId\n        name\n        price\n        ...ProductListItem_product\n      }\n    }\n  }\n}\n\nfragment GrapefulClubBanner_viewer on Viewer {\n  ...MembershipButtons_viewer\n}\n\nfragment MembershipButtons_viewer on Viewer {\n  isLoggedIn\n  user {\n    id\n    ...AuthDialog_user\n    conciergeUser {\n      userId\n      permissions {\n        id\n        oneCommerce {\n          id\n          preferredCustomer {\n            access\n          }\n        }\n      }\n      id\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n  }\n}\n\nfragment AuthDialog_user on User {\n  id\n  role\n  email\n  lastName\n  firstName\n  hasSSOAccount\n  shoppingWithCeoUser {\n    userId\n    id\n  }\n  cart {\n    id\n    eventId\n    eventHostFirstName\n  }\n}\n\nfragment ProductListItem_product on Product {\n  id\n  isSubscription\n  productPermissions {\n    oneCommerce {\n      preferredCustomer {\n        view\n        add\n      }\n      default {\n        view\n        add\n      }\n    }\n  }\n  ranking\n  company\n  freeUpsGroundShipping\n  productId\n  name\n  category\n  price\n  priceUSDmin\n  priceUSDmax\n  year\n  priceSale\n  reviewAverage\n  productURLslug\n  parentProduct\n  inventoryText\n  reviewTotal\n  staticUrl\n  images {\n    productCatalog\n    squareFront\n    id\n  }\n  content {\n    impactSmall\n    summary\n    id\n  }\n  promoCodeDiscount {\n    case4Cause {\n      case12PriceUSD\n      case6PriceUSD\n      case6SKU\n      case12SKU\n      donationEligible\n    }\n  }\n  inventoryClass\n  inventorySKU\n  inventoryQuantity\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '2028d079db5558dd419ba0c6d2901511';
export default node;
